/**
 * Comparador de palas - PadelHouse (tema Horizon).
 *
 * Sistema propio sin app ni login: persiste en localStorage (clave
 * `ph_comparar_v1`, distinta de favoritos). Guarda datos minimos de cada pala
 * (handle, titulo, url, imagen, precio, marca) para pintar la barra flotante sin
 * llamadas extra. Maximo 3 palas.
 *
 * Piezas:
 *  - Botones [data-phc-toggle] en las fichas: alternan guardado y estado; si ya
 *    hay 3, avisan "maximo 3" y no anaden.
 *  - Barra flotante fija abajo (se construye en JS y se anexa a <body>): visible
 *    cuando hay >=1 pala; miniaturas con quitar, boton "Comparar" (-> /comparar)
 *    y "Vaciar". Se oculta en la propia pagina /comparar.
 *  - Pagina /comparar [data-phc-page]: por cada handle guardado pide el fragmento
 *    Liquid /products/{handle}?view=comparador&section_id=card y lo inyecta como
 *    columna (con las 5 barras de Key Points ya calculadas en Liquid, identicas a
 *    la ficha). Fallback graceful si un handle no carga. Add-to-cart por columna.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ph_comparar_v1';
  var MAX_ITEMS = 3;
  // URL real de la pagina Shopify (handle "comparar" -> /pages/comparar).
  // Override opcional: define window.PH_COMPARAR_URL antes de cargar el script
  // (util si se crea un redirect corto /comparar -> /pages/comparar).
  var COMPARE_URL = window.PH_COMPARAR_URL || '/pages/comparar';

  /* Estado (localStorage) --------------------------------------------------- */

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.slice(0, MAX_ITEMS) : [];
    } catch (error) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* almacenamiento no disponible: no rompemos la pagina */
    }
  }

  function has(handle) {
    return readAll().some(function (item) {
      return item.handle === handle;
    });
  }

  function emitChange(items) {
    document.dispatchEvent(new CustomEvent('ph:comparar:change', { detail: { items: items } }));
  }

  /**
   * Alterna una pala. Devuelve:
   *  { added:true }            -> anadida
   *  { added:false }           -> quitada
   *  { added:false, full:true} -> no se anadio porque ya habia 3
   */
  function toggle(entry) {
    var items = readAll();
    var index = items.findIndex(function (item) {
      return item.handle === entry.handle;
    });
    if (index !== -1) {
      items.splice(index, 1);
      writeAll(items);
      emitChange(items);
      return { added: false };
    }
    if (items.length >= MAX_ITEMS) {
      return { added: false, full: true };
    }
    items.push(entry);
    writeAll(items);
    emitChange(items);
    return { added: true };
  }

  function removeHandle(handle) {
    var items = readAll().filter(function (item) {
      return item.handle !== handle;
    });
    writeAll(items);
    emitChange(items);
  }

  function clearAll() {
    writeAll([]);
    emitChange([]);
  }

  function entryFromButton(button) {
    return {
      handle: button.dataset.handle || '',
      title: button.dataset.title || '',
      url: button.dataset.url || '',
      image: button.dataset.image || '',
      price: button.dataset.price || '',
      vendor: button.dataset.vendor || ''
    };
  }

  /* Aviso transitorio (sin emojis) ----------------------------------------- */

  var toastTimer = null;
  function toast(message) {
    var el = document.querySelector('[data-phc-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'phc-toast';
      el.setAttribute('data-phc-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  /* Botones de ficha -------------------------------------------------------- */

  function paintButton(button, saved) {
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.classList.toggle('phc-btn--active', saved);
    var label = button.querySelector('[data-phc-label]');
    if (label) {
      // Etiqueta corta: el boton vive en una fila junto a Favoritos.
      label.textContent = saved ? 'Comparando' : 'Comparar';
    }
  }

  function initButtons(root) {
    var buttons = (root || document).querySelectorAll('[data-phc-toggle]');
    Array.prototype.forEach.call(buttons, function (button) {
      if (button.dataset.phcReady === 'true') return;
      button.dataset.phcReady = 'true';
      paintButton(button, has(button.dataset.handle || ''));
      button.addEventListener('click', function () {
        var result = toggle(entryFromButton(button));
        if (result.full) {
          toast('Solo puedes comparar 3 palas. Quita una para añadir otra.');
          return;
        }
        paintButton(button, result.added);
      });
    });
  }

  function refreshButtons() {
    var buttons = document.querySelectorAll('[data-phc-toggle]');
    Array.prototype.forEach.call(buttons, function (button) {
      paintButton(button, has(button.dataset.handle || ''));
    });
  }

  /* Barra flotante ---------------------------------------------------------- */

  var bar = null;

  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'phc-bar';
    bar.setAttribute('data-phc-bar', '');
    bar.hidden = true;
    bar.innerHTML =
      '<div class="phc-bar__inner">' +
      '<div class="phc-bar__thumbs" data-phc-bar-thumbs></div>' +
      '<div class="phc-bar__actions">' +
      '<span class="phc-bar__count" data-phc-bar-count></span>' +
      '<button type="button" class="phc-bar__clear" data-phc-clear>Vaciar</button>' +
      '<a class="phc-bar__go button" data-phc-go href="' + COMPARE_URL + '">Comparar</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('[data-phc-clear]').addEventListener('click', function () {
      clearAll();
    });

    bar.querySelector('[data-phc-bar-thumbs]').addEventListener('click', function (event) {
      var btn = event.target.closest('[data-phc-bar-remove]');
      if (!btn) return;
      removeHandle(btn.getAttribute('data-phc-bar-remove'));
    });

    return bar;
  }

  function renderBar() {
    // En la propia pagina /comparar no mostramos la barra (redundante).
    if (document.querySelector('[data-phc-page]')) {
      if (bar) bar.hidden = true;
      return;
    }
    var items = readAll();
    var el = buildBar();

    if (items.length === 0) {
      el.hidden = true;
      return;
    }
    el.hidden = false;

    var countEl = el.querySelector('[data-phc-bar-count]');
    countEl.textContent = 'Comparar (' + items.length + ')';

    var go = el.querySelector('[data-phc-go]');
    go.setAttribute('aria-disabled', items.length < 2 ? 'true' : 'false');
    go.classList.toggle('is-disabled', items.length < 2);

    var thumbs = el.querySelector('[data-phc-bar-thumbs]');
    thumbs.textContent = '';
    items.forEach(function (item) {
      var cell = document.createElement('div');
      cell.className = 'phc-bar__thumb';

      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        img.width = 48;
        img.height = 48;
        cell.appendChild(img);
      } else {
        var ph = document.createElement('span');
        ph.className = 'phc-bar__thumb-ph';
        cell.appendChild(ph);
      }

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'phc-bar__thumb-remove';
      remove.setAttribute('data-phc-bar-remove', item.handle);
      remove.setAttribute('aria-label', 'Quitar ' + (item.title || 'pala') + ' del comparador');
      remove.innerHTML =
        '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">' +
        '<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      cell.appendChild(remove);

      thumbs.appendChild(cell);
    });
  }

  /* Pagina /comparar -------------------------------------------------------- */

  function fragmentUrl(page, handle) {
    var view = page.getAttribute('data-fragment-view') || 'comparador';
    var sectionId = page.getAttribute('data-fragment-section') || 'card';
    var url = '/products/' + handle + '?view=' + encodeURIComponent(view) + '&section_id=' + encodeURIComponent(sectionId);
    // PREVIEW del tema SIN publicar: hay que propagar preview_theme_id para que el
    // fragmento se renderice con ESTE tema (el que tiene product.comparador.json y la
    // seccion ph-comparar-card). Sin esto, el fetch cae al tema PUBLICADO -> no existe
    // la seccion -> la tarjeta no llega. En PRODUCCION el parametro no existe y no se
    // anade nada, asi que funciona igual.
    // Ejemplo real: /products/siux-electra-pro-2026-fire-red?view=comparador&section_id=card&preview_theme_id=199933624654
    var previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) {
      url += '&preview_theme_id=' + encodeURIComponent(previewId);
    }
    return url;
  }

  function renderPage() {
    var page = document.querySelector('[data-phc-page]');
    if (!page) return;

    var grid = page.querySelector('[data-phc-page-grid]');
    var empty = page.querySelector('[data-phc-empty]');
    var countEl = page.querySelector('[data-phc-count]');
    var items = readAll();

    if (countEl) {
      if (items.length === 0) {
        countEl.textContent = '';
      } else {
        countEl.textContent = items.length === 1 ? '1 pala en el comparador' : items.length + ' palas en el comparador';
      }
    }

    if (items.length === 0) {
      if (empty) empty.hidden = false;
      if (grid) {
        grid.hidden = true;
        grid.textContent = '';
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (grid) {
      grid.hidden = false;
      grid.textContent = '';
    }

    items.forEach(function (item) {
      var col = document.createElement('div');
      col.className = 'phc-col';
      col.setAttribute('data-phc-col', item.handle);
      col.innerHTML = '<div class="phc-col__loading">Cargando ' + escapeHtml(item.title || item.handle) + '...</div>';
      grid.appendChild(col);

      var url = fragmentUrl(page, item.handle);
      // credentials same-origin: lleva la cookie de sesion (incl. la de la
      // contrasena de prelanzamiento si el usuario ya esta autenticado).
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (response) {
          return response.text().then(function (html) {
            return { ok: response.ok, status: response.status, html: html || '' };
          });
        })
        .then(function (res) {
          var html = res.html;
          if (!res.ok) {
            console.warn('[ph-comparar] fragmento HTTP ' + res.status + ' | url: ' + url + ' | body: ' + html.slice(0, 300));
            throw new Error('http-' + res.status);
          }
          if (html.trim() === '') {
            console.warn('[ph-comparar] fragmento VACIO | url: ' + url);
            throw new Error('vacio');
          }
          // La tarjeta valida contiene data-phc-card. Si NO esta, casi siempre es:
          // (a) el fetch cayo al tema publicado (sin la seccion) por falta de
          // preview_theme_id, o (b) vino la pagina de contrasena de prelanzamiento.
          if (html.indexOf('data-phc-card') === -1) {
            var looksPassword = html.indexOf('password') !== -1 || html.indexOf('Contrase') !== -1;
            console.warn('[ph-comparar] fragmento SIN tarjeta (' + (looksPassword ? 'parece pagina de contrasena' : 'tema sin la seccion / view no aplicado') + ') | url: ' + url + ' | body: ' + html.slice(0, 300));
            throw new Error('sin-tarjeta');
          }
          col.innerHTML = html;
        })
        .catch(function (error) {
          console.warn('[ph-comparar] no se pudo cargar "' + item.handle + '" (' + (error && error.message) + ') | url: ' + url);
          // Fallback graceful: la pala no se pudo renderizar.
          col.innerHTML =
            '<div class="phc-col__error">' +
            '<p>No se pudo cargar esta pala.</p>' +
            '<a href="/products/' + escapeAttr(item.handle) + '">' + escapeHtml(item.title || 'Ver ficha') + '</a>' +
            '<button type="button" class="phc-col__error-remove" data-phc-remove="' + escapeAttr(item.handle) + '">Quitar del comparador</button>' +
            '</div>';
        });
    });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function escapeAttr(str) {
    return escapeHtml(str);
  }

  /* Delegacion en la pagina: quitar columna + add-to-cart ------------------- */

  function initPageDelegation() {
    var page = document.querySelector('[data-phc-page]');
    if (!page || page.dataset.phcReady === 'true') return;
    page.dataset.phcReady = 'true';

    // Quitar pala (boton de la tarjeta o del fallback de error).
    page.addEventListener('click', function (event) {
      var rm = event.target.closest('[data-phc-remove]');
      if (rm) {
        event.preventDefault();
        removeHandle(rm.getAttribute('data-phc-remove'));
      }
    });

    // Add-to-cart por columna (progresivo: sin JS el form hace POST normal).
    page.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-phc-add-form]');
      if (!form) return;
      event.preventDefault();
      var button = form.querySelector('[data-phc-add]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      if (button) {
        button.disabled = true;
        button.dataset.originalLabel = button.textContent;
        button.textContent = 'Añadiendo...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(idInput.value), quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          if (button) {
            button.textContent = 'Añadida a la cesta';
            button.classList.add('is-added');
          }
          // Notifica al tema por si escucha refrescos de carrito.
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('ph:cart:added', { bubbles: true, detail: { id: idInput.value } }));
        })
        .catch(function () {
          if (button) {
            button.textContent = 'No se pudo añadir';
          }
        })
        .finally(function () {
          window.setTimeout(function () {
            if (button && button.classList.contains('is-added') === false) {
              button.disabled = false;
              button.textContent = button.dataset.originalLabel || 'Añadir a la cesta';
            } else if (button) {
              button.disabled = false;
            }
          }, 2200);
        });
    });
  }

  /* Init -------------------------------------------------------------------- */

  function init() {
    initButtons(document);
    renderBar();
    initPageDelegation();
    renderPage();
  }

  document.addEventListener('ph:comparar:change', function () {
    refreshButtons();
    renderBar();
    renderPage();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializa tras navegaciones/reemplazos de seccion del editor Horizon.
  document.addEventListener('shopify:section:load', function () {
    init();
  });

  /* API publica para otras piezas (buscador, favoritos). toggle() devuelve
     { added, full? }: quien llama pinta su propio aviso si full (el toast de
     este modulo vive en <body> y queda DEBAJO de un <dialog> abierto). */
  window.PHComparar = {
    has: has,
    items: readAll,
    toggle: toggle,
    remove: removeHandle,
    clear: clearAll,
    avisa: toast,
    MAX: MAX_ITEMS
  };
})();
